import React from 'react';
import { Box, Typography, Grid, Paper, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCategories, getTemplates, formatNumber } from '../utils/dashboardUtils';

/**
 * Dashboard form şablonları bölümü
 */
const TemplatesSection = ({ activeCategory, onCategoryChange }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const categories = getCategories(t);
  const templates = getTemplates(t);
  
  const filteredTemplates = activeCategory === 'Tümü' 
    ? templates 
    : templates.filter(template => template.category === activeCategory);

  return (
    <Box className="templates-section">
      <Box className="templates-header">
        <Typography className="templates-title">
          {t('form_templates')}
        </Typography>
      </Box>

      <Box className="template-categories">
        {categories.map((category, index) => (
          <Chip
            key={index}
            label={category}
            className={`category-chip ${activeCategory === category ? 'active' : ''}`}
            onClick={() => onCategoryChange(category)}
          />
        ))}
      </Box>

      <Grid container spacing={3}>
        {filteredTemplates.map((template) => (
          <Grid item xs={12} sm={6} md={4} key={template.id}>
            <Paper 
              className="template-card"
              elevation={0}
              onClick={() => navigate(`/form-builder?template=${template.id}`)}
              sx={{
                '--template-color': template.color,
                '--template-color-light': template.colorLight,
                '--template-bg': template.bg,
                cursor: 'pointer'
              }}
            >
              <Box className="template-icon">
                {template.icon}
              </Box>
              <Typography className="template-title">
                {template.title}
              </Typography>
              <Typography className="template-description">
                {template.description}
              </Typography>
              <Box className="template-meta">
                <Typography>
                  {template.category}
                </Typography>
                <Typography>
                  {formatNumber(template.usageCount)} {t('usage')}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TemplatesSection;
